













































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import {INetwork, INetworkInterfaceHelper, INetworkInterfaceRoutesHelper } from '../shared/services/models/Network';
import {IVersions} from '../shared/services/models/Versions';
import APIService from '../services/api';
import { isArray } from 'jquery';
import { faRetweet } from '@fortawesome/free-solid-svg-icons';


// The @Component decorator indicates the class is a Vue component
@Component({
    components: {
        // @ts-ignore
        CopyrightComponent : require('@/components/Copyright').default,
    },
    computed: {
        ...mapState(['networkConfig']),
    },
    methods: {
        ...mapActions(['updateNetworkConfig', 'SaveNetworkInterface']),
    },
})
export default class Network extends Vue {
    private networkConfig!: INetwork;


    private mounted() {
        // @ts-ignore
        this.updateNetworkConfig();
    }

    private get DummyVLAN(): any[] {
        const ret: INetworkInterfaceHelper[] = [];
        ret.push({
                            name: 'eth0',
                            vlanId: 1,
                            dhcp: 'false',
                            netmask: '/0',
                            gateway: '0.0.0.0',
                            address: '0.0.0.0',
                            nameserver: '',
                            vlanInterface: '',
                            routes: [],
                        });
        window.console.log(ret);
        return ret;
    }

    private get ValidVlanIds(): any[] {
        const ret: any[] = [];
        let i: number = 0;

        for (i = 1; i < 4097 ; i++ ) {
            ret.push({value: i, text: i});
        }

        return ret;
    }

    private get NetMasks(): any[] {
        const ret: any[] = [];

        ret.push({ value: '/30', text: '255.255.255.255 /32' });
        ret.push({ value: '/30', text: '255.255.255.254 /31' });
        ret.push({ value: '/30', text: '255.255.255.252 /30' });
        ret.push({ value: '/29', text: '255.255.255.248 /29' });
        ret.push({ value: '/28', text: '255.255.255.240 /28' });
        ret.push({ value: '/27', text: '255.255.255.224 /27' });
        ret.push({ value: '/26', text: '255.255.255.192 /26' });
        ret.push({ value: '/25', text: '255.255.255.218 /25' });
        ret.push({ value: '/24', text: '255.255.255.0 /24' });
        ret.push({ value: '/23', text: '255.255.254.0 /23' });
        ret.push({ value: '/22', text: '255.255.252.0 /22' });
        ret.push({ value: '/21', text: '255.255.248.0 /21' });
        ret.push({ value: '/20', text: '255.255.240.0 /20' });

        ret.push({ value: '/19', text: '255.255.224.0 /19' });
        ret.push({ value: '/18', text: '255.255.192.0 /18' });
        ret.push({ value: '/17', text: '255.255.128.0 /17' });
        ret.push({ value: '/16', text: '255.255.0.0 /16' });
        ret.push({ value: '/15', text: '255.254.0.0 /15' });
        ret.push({ value: '/14', text: '255.252.0.0 /14' });
        ret.push({ value: '/13', text: '255.248.0.0 /13' });
        ret.push({ value: '/12', text: '255.240.0.0 /12' });
        ret.push({ value: '/11', text: '255.224.0.0 /11' });
        ret.push({ value: '/10', text: '255.192.0.0 /10' });

        ret.push({ value: '/9', text: '255.128.0.0 /9' });
        ret.push({ value: '/8', text: '255.0.0.0 /8' });
        ret.push({ value: '/7', text: '254.0.0.0 /7' });
        ret.push({ value: '/6', text: '252.0.0.0 /6' });
        ret.push({ value: '/5', text: '248.0.0.0 /5' });
        ret.push({ value: '/4', text: '240.0.0.0 /4' });
        ret.push({ value: '/3', text: '224.0.0.0 /3' });
        ret.push({ value: '/2', text: '192.0.0.0 /2' });
        ret.push({ value: '/1', text: '128.0.0.0 /1' });
        ret.push({ value: '/0', text: '0.0.0.0 /0' });

        return ret;
    }

    private get Interfaces(): any[] {
        const ret: any[] = [];

        if (this.NetworkInterfaces && Array.isArray(this.NetworkInterfaces)) {
            this.NetworkInterfaces.forEach((n) => {
                if (n.vlanId === undefined || n.vlanId < 1) {
                        ret.push({ value: n.name, text: n.name });
                }
            });
        }

        window.console.log('In interfaces');
        window.console.log(ret);

        return ret;
    }

    private get MulticastInterfaces(): any[] {
        const ret: any[] = [];

        if (this.NetworkInterfaces && Array.isArray(this.NetworkInterfaces)) {
            this.NetworkInterfaces.forEach((n) => {
                        ret.push({ value: n.name, text: n.name });
            });
        }

        return ret;
    }

    private get NetworkInterfaces(): any[] {
        const ret: INetworkInterfaceHelper[] = [];
        // console.log('networkConfig', this.networkConfig);
        if (this.networkConfig) {
            Object.keys(this.networkConfig.network.ethernets).forEach((n) => {
                // console.log('ethernets', n);
                let address = '';
                if (this.networkConfig.network.ethernets[n].addresses !== undefined) {
                    address = this.networkConfig.network.ethernets[n].addresses[0] !== undefined ? this.networkConfig.network.ethernets[n].addresses[0] : '';
                }
                const gateway = this.networkConfig.network.ethernets[n].gateway4 !== undefined ? this.networkConfig.network.ethernets[n].gateway4 : '';
                const nameserver = (this.networkConfig.network.ethernets[n].nameservers && this.networkConfig.network.ethernets[n].nameservers.addresses) ? this.networkConfig.network.ethernets[n].nameservers.addresses[0] : '';
                const dhcp = (this.networkConfig.network.ethernets[n].dhcp4 !== undefined) ? this.networkConfig.network.ethernets[n].dhcp4 : 'false';
               // console.log("dhcp: (" + dhcp + ")" + this.networkConfig.network.ethernets[n].dhcp4 );

                window.console.log('nameserver: ' + nameserver);
                window.console.log(this.networkConfig.network.ethernets[n].nameservers);
                if (this.networkConfig.network.ethernets[n].routes === undefined) {
                    // this.networkConfig.network.ethernets[n].routes;
                }

                ret.push({
                    name: n,
                    vlanId: -1,
                    dhcp,
                    netmask: address.substr(address.indexOf('/')),
                    gateway,
                    address: address.substr(0, address.indexOf('/')),
                    nameserver,
                    vlanInterface: '',
                    routes: this.MakeRoutes(this.networkConfig.network.ethernets[n].routes),
                });
            });
            if (this.networkConfig.network.vlans) {
               Object.keys(this.networkConfig.network.vlans).forEach((n) => {
                    // console.log('vlan', n);
                    const net: any = this.networkConfig.network.vlans[n];

                    let dhcp: string = 'false';
                    let address: string = '0.0.0.0';
                    let netmask: string = '/0';
                    let gateway: string = '0.0.0.0';
                    let nameserver: string = '';

                    if (Array.isArray(net.addresses) && net.addresses.length > 0) {
                        const sp = net.addresses[0].split('/');

                        address = sp[0];
                        netmask = '/' + sp[1];
                    }

                    if (net.gateway4) {
                        gateway = net.gateway4;
                    }

                    if (net.nameservers && net.nameservers.addresses && net.nameservers.addresses.length > 0) {
                       nameserver = net.nameservers.addresses[0];
                    }

                    if (net.dhcp4 && net.dhcp4 !== 'false' && net.dhcp4 !== false) {
                        dhcp = 'true';
                    }

/*		    console.log(this.networkConfig.network.ethernets[n]);
 		    if(this.networkConfig.network.ethernets[n].routes == undefined)
                        this.networkConfig.network.ethernets[n].routes = [];
*/
                    const item = {
                            name: n,
                            vlanId: net.id,
                            dhcp,
                            netmask,
                            gateway,
                            address,
                            nameserver,
                            vlanInterface: net.link,
                            routes: this.MakeRoutes(net.routes),
                    };

                    /*if (net.routes && Array.isArray(net.routes)) {
                        net.routes.forEach((r: any) => {
                            const sp = r.to.split('/');

                            const addr: string = sp[0];
                            const netm: string = '/' + sp[1];

                            item.routes.push({
                                // @ts-ignore
                                to: addr,
                                // @ts-ignore
                                netmask: netm,
                                // @ts-ignore
                                via: r.via,
                            });
                        });
                    }*/

                    ret.push(item);

                });
           }
        }

        // console.log('ret', ret);
        return ret;
    }

    private DefaultGateway(): string {
        let ret: string = '0.0.0.0';

        Object.keys(this.networkConfig.network.ethernets).forEach((n) => {
            if (this.networkConfig.network.ethernets[n].addresses) {
                const net: any = this.networkConfig.network.ethernets[n];

                if (net.gateway4) {
                    ret = net.gateway4;
                }
            }
        });

        if (this.networkConfig.network.vlans != null) {
            Object.keys(this.networkConfig.network.vlans).forEach((n) => {
                if (this.networkConfig.network.vlans[n].addresses) {
                    const net: any = this.networkConfig.network.vlans[n];

                    if (net.gateway4) {
                        ret = net.gateway4;
                    }
                }
            });
        }
        return ret;
    }

    private get MulticastInterface(): string | null {
        let ret: string | null = null;

        if (this.NetworkInterfaces && Array.isArray(this.NetworkInterfaces)) {
            this.NetworkInterfaces.forEach((n) => {
                if (n.routes && Array.isArray(n.routes)) {
                    n.routes.forEach((r: any) => {
                        // console.log('r', r);
                        if (r.to === '224.0.0.0' && r.netmask === '/4' && r.via === '0.0.0.0') {
                            ret = n.name;
                        }
                    });
                }
            });
        }
 // console.log('M this.NetworkInterfaces', ret);
        return ret;
    }

    private MakeRoutes(routes: any[]) {
        const ret: INetworkInterfaceRoutesHelper[] = [];

        if (Array.isArray(routes)) {
            routes.forEach((r) => {
                const address = r.to.split('/');
                ret.push({
                    to: address[0],
                    via: r.via,
                    netmask: `/${address[1]}`,
                    table: r.table,
                });
            });
        }

        return ret;
    }

    private SaveInterface(i: INetworkInterfaceHelper) {
        // @ts-ignore
        window.console.log('saveinterface');
        window.console.log(i);
        APIService.SaveNetworkInterface(i);
    }

    private AddVLAN( i: INetworkInterfaceHelper) {
        APIService.AddVLAN(i);
    }

    private DelVLAN(i: INetworkInterfaceHelper) {
       APIService.DelVLAN(i);
    }
}
